<template>
  <div>
    <div v-if="requestError" class="search-box recovery-notice" role="alert">
      <p>{{ requestError }}</p>
      <button type="button" class="k-onboarding-button ob-orange" @click="updateSearchData" :disabled="requestState === 'loading'">Повторить загрузку</button>
      <router-link v-if="!getUser" to="/login">Войти</router-link>
    </div>
    <div class="search-box">
      <h5 class="text-center">Поиск рецептов</h5>
      <div>
        <p class="my-4">Поиск рецептов по названию</p>
      </div>
      <div>
        <BaseInput
            v-model="searchRecipe"
            @input="updateStorageSearchParams"
            placeholder="Название рецепта"
            class="search-input"
            clearable
        />
      </div>
      <div class="mt-2">
        <p class="my-4">Поиск рецептов по содержащимся ингредиентам</p>
        <div class="d-flex align-items-center k-check__accept-text ml-1 my-4" @click="changeAtLeastOne">
          <div class="k-ingredient-card__select" :class="{ active: isAtLeastOne }">
            <svg width="16" height="12" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.5 3.52308L3.21429 5L6.5 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div class="k-check-text m-0">Наличие хотя бы одного ингредиента в рецепте</div>
        </div>
      </div>
      <button
          class="k-onboarding-button ob-orange"
          @click="openDialogIngredientsInclude"
      >Добавить ингредиенты</button>
      <div v-if="selectedIngredientsInclude.length" class="d-flex flex-wrap mt-2" style="width: 100%; justify-content: center;">
        <IngredientCard
            v-for="(ingredient) in selectedIngredientsInclude"
            :key="`ingredient-include-${ingredient.id}-selected`"
            :id="ingredient.id"
            :title="ingredient.title"
            :description="getIngredientDescription(ingredient)"
            :cover_url="getCoverUrl(ingredient.cover_id)"
            :isActive="selectedIngredientsIdsInclude.includes(ingredient.id)"
            @click="clickIngredientInclude(ingredient)"
        />
      </div>
      <div v-else class="text-center" style="color: #A0A0A0;">
        Ингредиенты не выбраны
      </div>
      <div class="mt-2">
        <p class="my-4">Поиск рецептов по исключенным ингредиентам</p>
      </div>
      <button
          class="k-onboarding-button ob-orange"
          @click="openDialogIngredientsExclude"
      >Добавить ингредиенты</button>
      <div v-if="selectedIngredientsExclude.length" class="d-flex flex-wrap mt-2" style="width: 100%; justify-content: center;">
        <IngredientCard
            v-for="(ingredient) in selectedIngredientsExclude"
            :key="`ingredient-include-${ingredient.id}-selected`"
            :id="ingredient.id"
            :title="ingredient.title"
            :description="getIngredientDescription(ingredient)"
            :cover_url="getCoverUrl(ingredient.cover_id)"
            :isActive="selectedIngredientsIdsExclude.includes(ingredient.id)"
            @click="clickIngredientExclude(ingredient)"
        />
      </div>
      <div v-else class="text-center" style="color: #A0A0A0;">
        Ингредиенты не выбраны
      </div>
    </div>
    <div v-if="isReadyFilterRecipes">
      <div class="search-box my-4">
        {{ isAllRecipes ? 'Все рецепты' : 'Результаты поиска' }} {{ isLoading || requestError ? '' : `(${filteredRecipes.length} рецептов)` }}
      </div>
      <div class="k-subscribe__loading-wrapper" v-if="isLoading" style="background-color: #f9fafb">
        <k-spinner backgroundColor="#f9fafb"/>
      </div>
      <div v-else-if="filteredRecipes.length" class="d-flex flex-wrap mt-4" style="width: 100%; justify-content: center;">
        <DishCard
            v-for="(recipe) in filteredRecipes"
            :key="`recipe-${recipe.id}`"
            :id="recipe.id"
            :title="recipe.title"
            :cover_url="getCoverUrl(recipe.cover_id)"
            @click="clickRecipe(recipe)"
        />
      </div>
      <div v-else-if="!requestError" class="text-center my-4" style="color: #A0A0A0;">
        Ничего не удалось найти
      </div>
    </div>
    <div v-else class="search-box text-center my-4" style="color: #A0A0A0;">
      Для получения результатов поиска начните вводить название рецепта или добавьте включенные/исключенные ингредиенты
    </div>

    <ModalDialog
        :isShow="isShowDialogIngredientsInclude"
        :verticalCenter="false"
        @close="closeDialogIngredientsInclude">
      <div class="text-left" style="width: 100%;">
        <h5 class="text-center">Поиск рецептов по содержащимся ингредиентам</h5>
      </div>
      <div class="text-left my-2" style="width: 100%;">
        Поиск ингредиентов по названию
      </div>
      <div class="my-2" style="width: 100%;">
        <BaseInput
            v-model="searchIngredientInclude"
            @input="updateStorageSearchParams"
            clearable
            placeholder="Название ингредиента"
            class="search-input"
        />
      </div>
      <div class="k-subscribe__loading-wrapper" v-if="isLoading">
        <k-spinner />
      </div>
      <div v-else-if="filteredIngredientsInclude.length" class="d-flex flex-wrap mt-2" style="width: 100%; justify-content: center;">
        <IngredientCard
            v-for="(ingredient) in filteredIngredientsInclude"
            :key="`ingredient-include-${ingredient.id}`"
            :id="ingredient.id"
            :title="ingredient.title"
            :description="getIngredientDescription(ingredient)"
            :cover_url="getCoverUrl(ingredient.cover_id)"
            :isActive="selectedIngredientsIdsInclude.includes(ingredient.id)"
            @click="clickIngredientInclude(ingredient)"
        />
      </div>
      <div v-else-if="requestError" role="alert" class="recovery-notice">
        {{ requestError }}
        <button type="button" class="k-onboarding-button ob-orange" @click="updateSearchData">Повторить загрузку</button>
      </div>
      <div v-else class="text-center my-4" style="color: #A0A0A0;">
        Ничего не удалось найти
      </div>
    </ModalDialog>

    <ModalDialog
        :isShow="isShowDialogIngredientsExclude"
        :verticalCenter="false"
        @close="closeDialogIngredientsExclude">
      <div class="text-left" style="width: 100%;">
        <h5 class="text-center">Поиск рецептов по исключенным ингредиентам</h5>
      </div>
      <div class="text-left my-2" style="width: 100%;">
        Поиск ингредиентов по названию
      </div>
      <div class="my-2" style="width: 100%;">
        <BaseInput
            v-model="searchIngredientExclude"
            @input="updateStorageSearchParams"
            placeholder="Название ингредиента"
            class="search-input"
            clearable
        />
      </div>
      <div class="k-subscribe__loading-wrapper" v-if="isLoading">
        <k-spinner />
      </div>
      <div v-else-if="filteredIngredientsExclude.length" class="d-flex flex-wrap mt-2" style="width: 100%; justify-content: center;">
        <IngredientCard
            v-for="(ingredient) in filteredIngredientsExclude"
            :key="`ingredient-exclude-${ingredient.id}`"
            :id="ingredient.id"
            :title="ingredient.title"
            :description="getIngredientDescription(ingredient)"
            :cover_url="getCoverUrl(ingredient.cover_id)"
            :isActive="selectedIngredientsIdsExclude.includes(ingredient.id)"
            @click="clickIngredientExclude(ingredient)"
        />
      </div>
      <div v-else-if="requestError" role="alert" class="recovery-notice">
        {{ requestError }}
        <button type="button" class="k-onboarding-button ob-orange" @click="updateSearchData">Повторить загрузку</button>
      </div>
      <div v-else class="text-center my-4" style="color: #A0A0A0;">
        Ничего не удалось найти
      </div>
    </ModalDialog>

    <ModalDialog
        :isShow="isShowDialogCurrentRecipe"
        :verticalCenter="false"
        @close="closeDialogCurrentRecipe">
      <div style="width: 100%;" v-if="currentRecipe">
        <div class="text-center">
          <h5 class="my-4">{{ currentRecipe.title }}</h5>
          <img
              class="k-recipe__image k-recipe__about-image"
              :src="getCoverUrl(currentRecipe.cover_id)"
              alt="Изображение рецепта"
          >
          <div v-if="currentRecipeMenusTitles.length" class="my-4">
            Рецепт содержится в меню {{currentRecipeMenusTitles}}
          </div>
          <button
              v-for="(menu, i) of currentRecipeMenus"
              :key="`menu-open-${i}`"
              class="k-onboarding-button ob-orange"
              @click="openMenu(menu)"
          >
            Открыть в меню "{{getMenuTitle(menu)}}"
          </button>
        </div>
        <div class="col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height px-0 px-md-3">
          <div class="k-recipe__card-title k-recipe__card-title--additional">
            <span>Ингредиенты</span>
          </div>
          <div>
            <div
                class="d-flex align-items-center mb-2"
                v-for="(ingredient) in currentRecipeIngredients"
                :key="`current-recipe-ingredient-${ingredient.id}`">
              <span class="mr-4 k-recipe__ingridient-icon">
                <img :src="getCoverUrl(ingredient.cover_id)" alt="Изображение ингредиента">
              </span>
              <div class="k-recipe__ingridient-name">{{ ingredient.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </ModalDialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '../api/BaseApi';
import ModalDialog from "@/components/ModalDialog";
import IngredientCard from "@/components/IngredientCard";
import DishCard from "@/components/DishCard";
import KSpinner from '@/components/TheSpinner.vue';
import BaseInput from "@/components/elements/BaseInput";
import { readFailure } from '../utils/legacy-safety';

export default {
  name: 'Search',
  components: {
    BaseInput,
    DishCard,
    IngredientCard,
    ModalDialog,
    KSpinner,
  },
  data: () => ({
    isLoadedSearchDataFromStorage: false,
    searchData: null,
    requestState: 'idle',
    requestError: null,
    requestVersion: 0,
    searchDisposed: false,
    searchRecipe: '',
    searchIngredientInclude: '',
    searchIngredientExclude: '',
    isAtLeastOne: false,
    selectedIngredientsIdsInclude: [],
    selectedIngredientsIdsExclude: [],
    isShowDialogIngredientsInclude: false,
    isShowDialogIngredientsExclude: false,
    isShowDialogCurrentRecipe: false,
    currentRecipe: null,
    datetimeUpdated: null,
    minSymbolsInRecipeSearchInput: -1
  }),
  computed: {
    ...mapGetters([
      'getSubscribesAndSets',
      'getUser',
    ]),
    searchContext() {
      const data = this.$store.state.user.profileData || {};
      const rights = [...data.subscriptions || [], ...data.recipe_sets || []]
        .map(right => [right.id, right.menu_id || right.recipe_set_id, right.started_at, right.finished_at, right.is_paid].join(':')).sort();
      return JSON.stringify([this.getUser && this.getUser.id, rights]);
    },
    searchStorageKey() {
      return `onk:legacy-search:${this.getUser && this.getUser.id || 'guest'}`;
    },
    isReadyFilterRecipes() {
      return this.searchRecipe.length >= this.minSymbolsInRecipeSearchInput ||
          !!this.selectedIngredientsIdsInclude?.length ||
          !!this.selectedIngredientsIdsExclude?.length;
    },
    isAllRecipes() {
      return !this.searchRecipe.length &&
          !this.selectedIngredientsIdsInclude.length &&
          !this.selectedIngredientsIdsExclude.length;
    },
    filteredRecipes() {
      if (!this.searchData?.recipes ||
          (this.searchRecipe.length < this.minSymbolsInRecipeSearchInput &&
          !this.selectedIngredientsIdsInclude.length &&
          !this.selectedIngredientsIdsExclude.length)) {
        return [];
      }
      return Object
          .entries(this.searchData.recipes)
          .filter(([id, recipe]) => id && recipe.title)
          .map(([id, recipe]) => ({id, ...recipe}))
          .filter(el => {
            if (!this.searchRecipe) {
              return true;
            }
            return el.title.toLowerCase().includes(this.searchRecipe.toLowerCase())
          })
          .filter(el => {
            if (!this.selectedIngredientsIdsInclude.length && !this.selectedIngredientsIdsExclude.length) {
              return true;
            }
            if (this.selectedIngredientsIdsInclude.length) {
              if (this.isAtLeastOne) {
                const isContainsIngredientsInclude = this.selectedIngredientsIdsInclude.some(id => el.ingredient_ids.includes(id));
                if (!isContainsIngredientsInclude) {
                  return false;
                }
              } else {
                const isContainsIngredientsInclude = this.selectedIngredientsIdsInclude.every(id => el.ingredient_ids.includes(id));
                if (!isContainsIngredientsInclude) {
                  return false;
                }
              }
            }
            if (this.selectedIngredientsIdsExclude.length) {
              const isNonContainsIngredientsExclude = this.selectedIngredientsIdsExclude.every(id => !el.ingredient_ids.includes(id));
              if (!isNonContainsIngredientsExclude) {
                return false;
              }
            }
            return true;
          })
          .sort((a, b) => a.title.localeCompare(b.title));
    },
    filteredIngredientsInclude() {
      if (!this.searchData?.ingredients) {
        return [];
      }
      return Object
          .entries(this.searchData.ingredients)
          .filter(([id, ingredient]) => id && ingredient.title)
          .map(([id, ingredient]) => ({id, ...ingredient}))
          .filter(el => {
            if (!this.searchIngredientInclude) {
              return true;
            }
            if (el.alternative_titles) {
              try {
                if (JSON
                    .parse(el.alternative_titles)
                    .find(el => el.toLowerCase().includes(this.searchIngredientInclude.toLowerCase()))) {
                  return true;
                }
              } catch { /* do nothing */ }
            }
            return el.title.toLowerCase().includes(this.searchIngredientInclude.toLowerCase())
          })
          .sort((a, b) => a.title.localeCompare(b.title));
    },
    filteredIngredientsExclude() {
      if (!this.searchData?.ingredients) {
        return [];
      }
      return Object
          .entries(this.searchData.ingredients)
          .filter(([id, ingredient]) => id && ingredient.title)
          .map(([id, ingredient]) => ({id, ...ingredient}))
          .filter(el => {
            if (!this.searchIngredientExclude) {
              return true;
            }
            if (el.alternative_titles) {
              try {
                if (JSON
                    .parse(el.alternative_titles)
                    .find(el => el.toLowerCase().includes(this.searchIngredientExclude.toLowerCase()))) {
                  return true;
                }
              } catch { /* do nothing */ }
            }
            return el.title.toLowerCase().includes(this.searchIngredientExclude.toLowerCase())
          })
          .sort((a, b) => a.title.localeCompare(b.title));
    },
    selectedIngredientsInclude() {
      if (!this.searchData?.ingredients) {
        return [];
      }
      return this.selectedIngredientsIdsInclude.map(id => ({
        id,
        ...this.searchData.ingredients[id]
      }));
    },
    selectedIngredientsExclude() {
      if (!this.searchData?.ingredients) {
        return [];
      }
      return this.selectedIngredientsIdsExclude.map(id => ({
        id,
        ...this.searchData.ingredients[id]
      }));
    },
    currentRecipeIngredients() {
      if (!this.currentRecipe?.ingredient_ids?.length) {
        return [];
      }
      return this.currentRecipe.ingredient_ids.map(id => ({
        id,
        ...this.searchData.ingredients[id]
      }))
    },
    currentRecipeMenus() {
      if (!this.currentRecipe?.id) {
        return null;
      }
      return Object
          .entries(this.searchData.menus)
          .map(([id, menu]) => ({id, ...menu}))
          .filter(menu => menu.recipe_ids.includes(this.currentRecipe.id) && this.$store.getters.getIdsToShow.includes(menu.id));
    },
    currentRecipeMenusTitles() {
      return this.currentRecipeMenus.map(menu => `"${this.getMenuTitle(menu)}"`).join(', ');
    },
    isLoading() {
      return this.requestState === 'loading' && !this.searchData;
    },
  },
  watch: {
    searchContext() {
      this.requestVersion++;
      this.searchData = null;
      this.isShowDialogCurrentRecipe = false;
      this.currentRecipe = null;
      this.loadSearchDataFromStorage();
      this.updateSearchData();
    },
  },
  mounted() {
    this.loadSearchDataFromStorage();
    this.updateSearchData();
  },
  beforeDestroy() {
    this.searchDisposed = true;
    this.requestVersion++;
  },
  methods: {
    loadSearchDataFromStorage() {
      this.searchRecipe = '';
      this.searchIngredientInclude = '';
      this.searchIngredientExclude = '';
      this.selectedIngredientsIdsInclude = [];
      this.selectedIngredientsIdsExclude = [];
      try {
        // The catalog is fetched fresh; only this signed-in account's filters
        // survive a reload. Legacy shared catalog keys are never read.
        const saved = JSON.parse(window.localStorage.getItem(this.searchStorageKey) || 'null');
        if (!saved) return;
        for (const key of ['searchRecipe', 'searchIngredientInclude', 'searchIngredientExclude']) {
          if (typeof saved[key] === 'string') this[key] = saved[key];
        }
        for (const key of ['selectedIngredientsIdsInclude', 'selectedIngredientsIdsExclude']) {
          if (Array.isArray(saved[key])) this[key] = saved[key].filter(id => typeof id === 'string');
        }
        this.isAtLeastOne = saved.isAtLeastOne === true;
      } catch (_) { /* Optional local preferences cannot block search. */ }
    },
    async updateSearchData() {
      const version = ++this.requestVersion;
      const context = this.searchContext;
      this.requestState = 'loading';
      this.requestError = null;
      try {
        const response = await api.get('search', { type: 'test' }, { timeout: 12000 });
        if (this.searchDisposed || version !== this.requestVersion || context !== this.searchContext) return;
        if (!response.data.success || !response.data.data) {
          const error = new Error('SearchUnavailable');
          error.response = response;
          throw error;
        }
        this.searchData = response.data.data;
        this.datetimeUpdated = Date.now();
        this.requestState = 'success';
        this.selectedIngredientsIdsInclude = this.selectedIngredientsIdsInclude.filter(id => this.searchData.ingredients[id]);
        this.selectedIngredientsIdsExclude = this.selectedIngredientsIdsExclude.filter(id => this.searchData.ingredients[id]);
      } catch (error) {
        if (this.searchDisposed || version !== this.requestVersion || context !== this.searchContext) return;
        this.requestState = 'error';
        this.requestError = readFailure(error, 'Не удалось загрузить поиск. Повторите запрос.');
      }
    },
    getCoverUrl(id) {
      return `${process.env.VUE_APP_MEDIA_BASE_URL}/${id}`;
    },
    getMenuTitle(menu) {
      return this.getSubscribesAndSets.find(s => s.id === menu.id)?.title;
    },
    getMenuUrl(menu) {
      const params = `?back_search=t&search=${this.currentRecipe.title}&set=all`;
      const sub = this.getSubscribesAndSets.find(el => el.id === menu.id);
      if (!sub?.recipeSetTypes?.length) {
        return `/regular/${menu.id}/${params}`;
      }
      return `/${sub.recipeSetTypes[0]}/${menu.id}/${params}`;
    },
    openMenu(menu) {
      this.$router.push(this.getMenuUrl(menu));
    },
    clickRecipe(recipe) {
      this.currentRecipe = recipe;
      this.isShowDialogCurrentRecipe = true;
      this.updateStorageSearchParams();
    },
    clickIngredientInclude(ingredient) {
      if (this.selectedIngredientsIdsInclude.includes(ingredient.id)) {
        this.selectedIngredientsIdsInclude.splice(this.selectedIngredientsIdsInclude.indexOf(ingredient.id), 1);
      } else {
        this.selectedIngredientsIdsInclude.push(ingredient.id);
      }
      this.updateStorageSearchParams();
    },
    clickIngredientExclude(ingredient) {
      if (this.selectedIngredientsIdsExclude.includes(ingredient.id)) {
        this.selectedIngredientsIdsExclude.splice(this.selectedIngredientsIdsExclude.indexOf(ingredient.id), 1);
      } else {
        this.selectedIngredientsIdsExclude.push(ingredient.id);
      }
      this.updateStorageSearchParams();
    },
    updateStorageSearchParams() {
      const saved = {};
      for (const key of ['searchRecipe', 'searchIngredientInclude', 'searchIngredientExclude', 'selectedIngredientsIdsInclude', 'selectedIngredientsIdsExclude', 'isAtLeastOne']) saved[key] = this[key];
      try { window.localStorage.setItem(this.searchStorageKey, JSON.stringify(saved)); } catch (_) { /* Optional. */ }
    },
    openDialogIngredientsInclude() {
      this.isShowDialogIngredientsInclude = true;
      this.updateStorageSearchParams();
    },
    openDialogIngredientsExclude() {
      this.isShowDialogIngredientsExclude = true;
      this.updateStorageSearchParams();
    },
    closeDialogIngredientsInclude() {
      this.isShowDialogIngredientsInclude = false;
      this.updateStorageSearchParams();
    },
    closeDialogIngredientsExclude() {
      this.isShowDialogIngredientsExclude = false;
      this.updateStorageSearchParams();
    },
    closeDialogCurrentRecipe() {
      this.isShowDialogCurrentRecipe = false;
      this.updateStorageSearchParams();
    },
    changeAtLeastOne() {
      this.isAtLeastOne = !this.isAtLeastOne;
      this.updateStorageSearchParams();
    },
    getIngredientDescription(ingredient) {
      if (!ingredient.alternative_titles) {
        return null;
      }
      try {
        const json = JSON.parse(ingredient.alternative_titles);
        return json.join(', ');
      } catch (e) {
        console.error(e);
        return null;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.search-box.recovery-notice { z-index: auto; }
.search-box {
  margin-top: 20px;
  margin-left: 5%;
  margin-right: 5%;
  width: 90%;
}

.search-input {
  width: 100%;
}

.k-onboarding-button {
  padding-left: 20px;
  padding-right: 20px;
  margin: 4px;
}

.k-recipe__image {
  max-width: 500px;
}

.k-recipe__card {
  max-width: 500px;
  margin: auto;
}

@media (max-width: 767.98px) {
  .search-box {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    width: calc(100% - 20px);
  }

  .k-onboarding-button {
    width: 100%;
    margin: 4px 0 4px 0;
  }

  .k-recipe__image {
    max-width: 100%;
  }

  .k-recipe__card {
    max-width: 100%;
    margin: 0;
  }
}

.k-subscribe__loading-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
}

.k-ingredient-card__select {
  border: 1px solid #F7981E;
  box-sizing: border-box;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: 28px;
  height: 28px;
  margin-right: 5px;

  svg {
    display: none;
    width: 17px;
    height: 13px;
  }

  &.active {
    background: #F7981E;
    svg {
      display: block;
    }
  }
}

.k-check__accept-text {
  font-size: 12px;
  color: #A0A0A0;
  position: relative;

  .k-check-text {
    display: block;
  }

  @media screen and (max-width: 345px) {
    .k-ingredient-card__select {
      position: relative;
      transform: unset;;
    }
  }
}
</style>
